import { Box, Grid, GridColumn, Text } from "@modernatx-internal/component-library";
import React from "react";

import { ContentComponentProps, PageFooterContent } from "@/content-V2/types";

export const PageFooter: React.FC<ContentComponentProps<PageFooterContent>> = ({
  backgroundColor,
  color,
  children,
  inlineCopyright = false,
  legalText,
  links,
  logo,
  socials,
  variant,
  veevaCode
}) => {
  const year = React.useMemo(() => new Date().getFullYear(), []);

  const footerContent = (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: ["column", null, "row"],
          gap: 10
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: ["column", null, "row"],
            gap: [10, null, 16],
            py: 3,
            "& a, & button": {
              color
            },
            "& a:hover, & button:hover": {
              color
            }
          }}
        >
          {children}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            marginInlineStart: [0, null, "auto"]
          }}
        >
          <Box sx={{ display: "flex", justifyContent: ["start", null, "end"] }}>{logo}</Box>
          <Box sx={{ display: "flex", color, gap: 3 }}>{socials}</Box>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {legalText}
        <Box
          sx={{
            display: "flex",
            flexDirection: ["column", null, "row"],
            gap: [7, null, 10]
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: ["column", null, "row"],
              gap: [7, null, 10],
              "& a, & button": {
                color
              },
              "& a:hover, & button:hover": {
                color
              }
            }}
          >
            {links}
          </Box>
          <Box
            sx={{
              display: inlineCopyright ? undefined : "flex",
              gap: inlineCopyright ? undefined : 1,
              marginInlineStart: [0, null, "auto"]
            }}
          >
            <Text
              sx={{
                whiteSpace: "nowrap"
              }}
            >
              © {year}
              {/* When inlineCopyright is set, the wrapping Box below drops its flex "gap" (see
                  display/gap toggle above), so without this non-breaking space there would be no
                  visible space before the veeva code, and "© {year}" could otherwise be orphaned
                  alone on a line if a plain space were used instead. */}
              {inlineCopyright && "\u00A0"}
            </Text>
            {veevaCode}
          </Box>
        </Box>
      </Box>
    </>
  );

  if (variant === "uniform-12") {
    return (
      <Box
        as="footer"
        sx={{
          backgroundColor,
          color,
          py: 10
        }}
      >
        <Grid variant="uniform-12">
          <GridColumn sx={{ gap: [10, null, 26] }}>{footerContent}</GridColumn>
        </Grid>
      </Box>
    );
  }

  return (
    <Box
      as="footer"
      sx={{
        backgroundColor,
        color,
        display: "flex",
        flexDirection: "column",
        gap: [10, null, 26],
        px: [5, null, 8],
        py: 10
      }}
    >
      {footerContent}
    </Box>
  );
};
